export default "__VITE_ASSET__CASjUyf7__"